export default __webpack_public_path__ + "static/media/vizualize.4ce1c57b.svg";